export const adminRoutes = [
  '/users',
  '/overview',
  '/users-overview',
  '/proposals-overview',
  '/referrals-overview',
];
